import React from 'react';

import ChartLegendVisibilityMenu, { ChartLegendVisibilityMenuProps } from 'components/charts/chart-legend-visibility-menu';

type Props = Omit<ChartLegendVisibilityMenuProps, 'title' | 'hideLabel' | 'showLabel'>;

const DataLabChartLegendVisibilityMenu: React.FC<Props> = (props) => (
  <ChartLegendVisibilityMenu {...props} title="Legend options" hideLabel="Hide legend" showLabel="Show legend" />
);

export default DataLabChartLegendVisibilityMenu;
